import React from "react";
import DefaultProduct from "../../gallery/default/placeholder.png";

function ProductCard({ product, goToTop }) {
  return (
    <>
      <div className="card p-0">
        <div style={{ height: "212px" }}>
          <a
            onClick={goToTop}
            href={`${process.env.REACT_APP_STORE_URL}/product/${product.slug}`}
            className="align-items-center"
            style={{
              overflow: "hidden",
              display: "flex",
              height: "100%",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "212px",
                zIndex: "1",
                textAlign: "center",
                overflow: "hidden",
                borderTopRightRadius: "8px",
                borderTopLeftRadius: "8px",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "lightgray 50%",
                  backgroundImage: `url(${product.image_path ? product.image_path : DefaultProduct})`,
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  filter: "blur(50px)",
                  zIndex: "-1",
                }}
              />
              <img
                src={product.image_path ? product.image_path : DefaultProduct}
                alt={product.title}
                style={{
                  width: "auto",
                  height: "212px",
                }}
              />
            </div>
          </a>
        </div>

        <div className="card-body p-3">
          <h6
            className="mb-3"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
            }}
          >
            <a onClick={goToTop} href={`${process.env.REACT_APP_STORE_URL}/product/${product.slug}`} className={"product-name text-decoration-none"}>
              {product.name ? product.name : ""}
            </a>
          </h6>
          <p
            className="mb-3 product-cat"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
            }}
          >
            {product.category_id ? product.category_id : ""}
          </p>
          <div className="d-flex justify-content-between align-content-center">
            <p className="product-price mb-0 mt-1">£{product.price}</p>
            <div>
              <a onClick={goToTop} href={`${process.env.REACT_APP_STORE_URL}/product/${product.slug}`} className="btn btn-buy-now">
                Buy Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default ProductCard;
